export default __webpack_public_path__ + "static/media/maure_de_bretagne10.088f88e6.jpg";